export const empreendimentosParaSelect = (empreendimentos) => 
  empreendimentos.map(({ id, nomeDaConstrutora, nomeDoEmpreendimento }) => (
    { value: id, label: `${nomeDoEmpreendimento} - ${nomeDaConstrutora}`, nomeDoEmpreendimento, nomeDaConstrutora }
  ));